import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaCamera,
  FaStar,
  FaRocket,
  FaMobileAlt,
  FaCheckCircle,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const ProfessionalVideographyServicesInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Professional Videography Services in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Elevate Your Vision</Subheading>}
        heading={
          <Heading>
            Professional <span tw="text-primary-500">Videography Services</span>{" "}
            in Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we offer professional videography services in
            **Bur Dubai**, delivering cinematic quality and creative
            storytelling to bring your vision to life. Capture your moments with
            unmatched expertise.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1505236858219-8359eb29e329?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2662&q=80",
          "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80",
          "https://images.unsplash.com/photo-1552581234-26160f608093?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Book Your Shoot"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Videography in Bur Dubai"
        description="We provide top-tier videography services with a professional touch."
        cards={[
          {
            icon: <FaCamera color="#ff5464" size={40} />,
            title: "Cinematic Excellence",
            description: "High-quality footage with a polished finish.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Creative Storytelling",
            description: "Compelling narratives tailored to your needs.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Timely Delivery",
            description: "Fast turnaround without compromising quality.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Multi-Platform Ready",
            description: "Videos optimized for all devices and platforms.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted by Clients",
            description: "Bur Dubai’s preferred videography experts.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Customized Solutions",
            description:
              "Personalized services for events, brands, or campaigns.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Professional Videography Process"
        description={
          <Description>
            We deliver stunning videos with a meticulous process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your vision and objectives.</li>
              <li>Planning: Develop a detailed shot list and storyboard.</li>
              <li>
                Filming: Capture high-quality footage with professional gear.
              </li>
              <li>Editing: Enhance with color grading, effects, and sound.</li>
              <li>Delivery: Provide polished videos ready for use.</li>
              <li>Support: Offer ongoing assistance and revisions.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1570913196677-6121448dd763?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80",
          "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80",
          "https://images.unsplash.com/photo-1531884070720-875c7622d4c6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Videography Wins in Bur Dubai"
        description="Our professional videography has transformed brands and events."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Brand Impact",
            description: "Elevated visibility with stunning campaign videos.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "94% approval from Bur Dubai clients.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Event Success",
            description: "Captured memorable moments for local events.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={
          <Subheading>Ready for Professional Videography?</Subheading>
        }
        heading="Professional Videography in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for expert videography services in Bur
            Dubai. Get cinematic, high-quality videos to showcase your brand or
            event—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1539786774582-5a6d5dabde2c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80",
          "https://images.unsplash.com/photo-1581338834647-b0fb40704e21?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2574&q=80",
          "https://images.unsplash.com/photo-1524658171180-c54ddfccc559?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
